import * as yup from 'yup';
import { ZIP_CODE } from '../../../../utils/validation';

const companyInitForm = (company?: ICompany | null) => {
  return {
    companyUpdated: false,
    name: company?.name ?? '',
    siret: company?.siret ?? '',
    address: company?.address ?? '',
    postalCode: company?.postalCode ?? '',
    city: company?.city ?? '',
    country: company?.country ?? '',
  };
};
const companyFormSchema = yup.object({
  name: yup.string(),
  siret: yup.string(),
  address: yup.string(),
  city: yup.string(),
  country: yup.string(),
  postalCode: yup.number().typeError(ZIP_CODE.type),
  enableNewsLetter: yup.bool(),
});

export { companyFormSchema, companyInitForm };
